export default __webpack_public_path__ + "static/media/mobile_vertical_dots.f9e0d50e.svg";